export default function ValueSection() {
  const earningNotes = [
    {
      icon: "ri-cash-line",
      title: "基础稿费",
      desc: "录用即付的固定金额，按条/篇计算，是吃瓜投稿最稳的收入底盘。",
    },
    {
      icon: "ri-line-chart-line",
      title: "热度加成",
      desc: "爆款瓜带来的额外奖励，阅读、转发冲高后触发，属于意外的惊喜。",
    },
    {
      icon: "ri-gift-2-line",
      title: "首发与独家奖金",
      desc: "抢到全网首发的料，平台常设专项奖金，先手优势直接变现。",
    },
    {
      icon: "ri-repeat-line",
      title: "长期供稿关系",
      desc: "稳定供应硬料的投稿人有机会谈更高档位或月度保底，越投越熟越值钱。",
    },
  ];

  return (
    <section
      id="value"
      className="scroll-mt-20 bg-background-100/70 py-16 md:py-20"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-accent-600">收益构成</p>
            <h2 className="mt-2 text-3xl text-foreground-950 md:text-4xl">稿费不只一个来源</h2>
            <p className="mt-3 max-w-2xl text-foreground-600">
              吃瓜投稿赚钱的关键，是搞清楚一份收益里到底有几笔钱。分清哪部分是保底、哪部分是加成，你才不会低估自己的料。
            </p>
          </div>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          {earningNotes.map((e) => (
            <div
              key={e.title}
              className="flex gap-4 rounded-2xl bg-background-50 p-6 ring-1 ring-background-200"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-2xl text-accent-700">
                <i className={e.icon} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="text-lg font-semibold text-foreground-950">{e.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{e.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl bg-foreground-950 text-background-50">
          <div className="grid gap-8 p-8 md:grid-cols-[1fr_1.1fr] md:p-10">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-1.5 text-sm font-medium">
                <i className="ri-calculator-line" aria-hidden="true"></i>
                一起来算一笔账
              </span>
              <h3 className="mt-4 text-2xl text-background-50 md:text-3xl">把料投对，稿费翻倍不是梦</h3>
            </div>
            <ul className="space-y-3 text-sm leading-relaxed text-background-200 md:text-base">
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-fill mt-1 text-secondary-400" aria-hidden="true"></i>
                <span>一条带证据的独家图文按 150 元录用，加上首发奖金 50 元，当篇到手 200 元。</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-fill mt-1 text-secondary-400" aria-hidden="true"></i>
                <span>若后续内容冲上热门触发 100 元热度加成，这篇瓜的最终收益可达 300 元。</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-checkbox-circle-fill mt-1 text-secondary-400" aria-hidden="true"></i>
                <span>稳定供稿并谈好更高档位后，月收入结构会越来越清晰、可预期。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}